import { render, staticRenderFns } from "./PersonProfileHistoryTransactionInformation.vue?vue&type=template&id=cc74af88&scoped=true&"
import script from "./PersonProfileHistoryTransactionInformation.vue?vue&type=script&lang=js&"
export * from "./PersonProfileHistoryTransactionInformation.vue?vue&type=script&lang=js&"
import style0 from "./PersonProfileHistoryTransactionInformation.vue?vue&type=style&index=0&id=cc74af88&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc74af88",
  null
  
)

export default component.exports